"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clientSide = require("../utils/clientSide");
var _GoogleAnalyticsConnector = _interopRequireDefault(require("./GoogleAnalyticsConnector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = function _default() {
  var contextHolder = {};
  var getContextKeys = function getContextKeys() {
    return Object.keys(contextHolder);
  };
  return {
    setDimension: function setDimension(key, value) {
      if (_GoogleAnalyticsConnector.default.isEnabled() && (0, _clientSide.isClientSide)()) {
        _GoogleAnalyticsConnector.default.set(key, value);
      } else {
        contextHolder[key] = value;
      }
    },
    flush: function flush() {
      if (!(0, _clientSide.isClientSide)()) {
        throw new Error('The dimension manager could not flush in server');
      }
      getContextKeys().forEach(function (key) {
        _GoogleAnalyticsConnector.default.set(key, contextHolder[key]);
      });
      contextHolder = {};
    },
    flushToScripts: function flushToScripts() {
      if ((0, _clientSide.isClientSide)()) {
        throw new Error('The dimension manager could not flush to script in client');
      }
      var scripts = getContextKeys().map(function (key) {
        return _GoogleAnalyticsConnector.default.createSetScript(key, contextHolder[key]);
      });
      contextHolder = {};
      return scripts;
    }
  };
};
exports.default = _default;
//# sourceMappingURL=DimensionConnector.js.map